import React from "react";
import Select from "react-select";
import { useNewsLetter } from "./useNewsLetter";
import RefreshIcon from "../../../asset/refresh-icon.png";
import EditLogo from "../../../asset/editLogo.png";
import "./NewsLetter.css";

const TYPES = [
  ["Berita", "Berita"],
  ["Keterlambatan", "Keterlambatan"],
  ["SIA", "S / I / A"],
];

const up = (value) => (value ? value.toUpperCase() : "");

const selectStyles = (isError) => ({
  control: (base, state) => ({
    ...base,
    minHeight: 36,
    borderRadius: 8,
    borderColor: isError
      ? "#d64545"
      : state.isFocused
      ? "dodgerblue"
      : "#e4e7eb",
    boxShadow: "none",
    fontSize: 14,
  }),
  menu: (base) => ({ ...base, zIndex: 20 }),
});

const Field = ({ label, isError, className = "", children }) => (
  <div className={`nl-field ${className}`}>
    {label && (
      <label className={`nl-label ${isError ? "is-error" : ""}`}>{label}</label>
    )}
    {children}
  </div>
);

const NewsLetter = () => {
  const {
    isType,
    setIsType,
    reFormat,
    operatorPick,
    setOperatorPick,
    inputS,
    setInputS,
    inputI,
    setInputI,
    inputA,
    setInputA,
    dataUser,
    handleKirimNewsLetter,
    title,
    setTitle,
    subTitle,
    setSubTitle,
    tglTerlambat,
    setTglTerlambat,
    until,
    setUntil,
    listNewsLetter,
    isError,
    setIsRefresh,
    handleChangeEdit,
    handleFormChange,
    handleKirim,
    handleDelete,
  } = useNewsLetter();

  const err = isError ? " is-error" : "";

  const operatorSelect = (
    <Select
      placeholder="Pilih Operator"
      options={reFormat}
      value={operatorPick || ""}
      onChange={setOperatorPick}
      styles={selectStyles(isError)}
    />
  );

  // Baris edit / tanggal "Sampai" — sama untuk ketiga jenis kartu
  const renderEditBar = (data, index) => (
    <div className="nl-editbar">
      <button
        className="nl-icon-btn"
        title="Edit"
        aria-label="Edit"
        onClick={() => handleChangeEdit(data, index)}
      >
        <img src={EditLogo} alt="" />
      </button>
      {data && data.isEdit ? (
        <>
          <button
            className="nl-btn nl-btn-danger"
            onClick={() => handleDelete(data, index)}
          >
            Delete
          </button>
          <input
            className={`nl-input nl-input-date${err}`}
            type="date"
            name="until"
            value={data && data.until}
            onChange={(e) => handleFormChange(data, index, e)}
          />
          <button
            className="nl-btn nl-btn-success"
            onClick={() => handleKirim(data, index)}
          >
            Kirim
          </button>
        </>
      ) : (
        <span className="nl-until">Sampai : {data && data.until}</span>
      )}
    </div>
  );

  const isMe = (obj) => (dataUser.id === obj.id ? "is-me" : "");

  return (
    <div className="container-payroll">
      <div className="wrapper-card-payroll padding-mobile-newsletter newsletter-page">
        {/* ===== Form header ===== */}
        <div className="nl-form">
          <div className="nl-row">
            <Field label="Judul" isError={isError} className="nl-grow">
              <input
                className={`nl-input${err}`}
                type="text"
                placeholder="Judul Berita"
                value={up(title)}
                onChange={(e) => setTitle(e.target.value)}
              />
            </Field>
            <Field label="Sampai Tgl" isError={isError}>
              <input
                className={`nl-input nl-input-date${err}`}
                type="date"
                value={until}
                onChange={(e) => setUntil(e.target.value)}
              />
            </Field>
            <button
              className="nl-icon-btn nl-icon-btn-lg"
              title="Muat ulang"
              aria-label="Muat ulang"
              onClick={() => setIsRefresh(true)}
            >
              <img src={RefreshIcon} alt="" />
            </button>
          </div>

          <div className="nl-segmented" role="radiogroup" aria-label="Jenis">
            {TYPES.map(([value, label]) => (
              <button
                key={value}
                type="button"
                role="radio"
                aria-checked={isType === value}
                className={`nl-seg ${isType === value ? "is-active" : ""}`}
                onClick={() => setIsType(value)}
              >
                {label}
              </button>
            ))}
          </div>

          {isType === "Berita" && (
            <div className="nl-row">
              <Field label="Info" isError={isError} className="nl-grow">
                <input
                  className={`nl-input${err}`}
                  type="text"
                  placeholder="Info"
                  value={up(subTitle)}
                  onChange={(e) => setSubTitle(e.target.value)}
                />
              </Field>
              <button
                className="nl-btn nl-btn-primary"
                onClick={() => handleKirimNewsLetter("Berita")}
              >
                Kirim
              </button>
            </div>
          )}

          {isType === "Keterlambatan" && (
            <div className="nl-row">
              <Field label="Sub Title" isError={isError}>
                <input
                  className={`nl-input${err}`}
                  type="text"
                  placeholder="Info"
                  value={up(subTitle)}
                  onChange={(e) => setSubTitle(e.target.value)}
                />
              </Field>
              <Field label="Tgl Terlambat" isError={isError}>
                <input
                  className={`nl-input${err}`}
                  type="text"
                  placeholder="Tgl Terlambat"
                  value={up(tglTerlambat)}
                  onChange={(e) => setTglTerlambat(e.target.value)}
                />
              </Field>
              <Field label="Nama" isError={isError} className="nl-select">
                {operatorSelect}
              </Field>
              <button
                className="nl-btn nl-btn-primary"
                onClick={() => handleKirimNewsLetter("Keterlambatan")}
              >
                Kirim
              </button>
            </div>
          )}

          {isType === "SIA" && (
            <div className="nl-row">
              <Field label="Sub Title" isError={isError}>
                <input
                  className={`nl-input${err}`}
                  type="text"
                  placeholder="Info"
                  value={up(subTitle)}
                  onChange={(e) => setSubTitle(e.target.value)}
                />
              </Field>
              <Field label="Nama" isError={isError} className="nl-select">
                {operatorSelect}
              </Field>
              {[
                ["S", inputS, setInputS],
                ["I", inputI, setInputI],
                ["A", inputA, setInputA],
              ].map(([key, val, setter]) => (
                <Field
                  key={key}
                  label={key}
                  isError={isError}
                  className="nl-sia"
                >
                  <input
                    className={`nl-input nl-input-sia${err}`}
                    type="number"
                    placeholder={key}
                    value={val ? val : ""}
                    onChange={(e) => setter(e.target.value)}
                    onWheel={(e) => e.target.blur()}
                  />
                </Field>
              ))}
              <button
                className="nl-btn nl-btn-primary"
                onClick={() => handleKirimNewsLetter("SIA")}
              >
                Kirim
              </button>
            </div>
          )}
        </div>

        {/* ===== Berita ===== */}
        {listNewsLetter &&
          listNewsLetter.berita.map((data, index) => (
            <article className="nl-card" key={`berita-${index}`}>
              <div className="nl-card-head">
                <div>
                  <span className="nl-badge nl-badge-berita">Berita</span>
                  <h3 className="nl-card-title">{up(data && data.title)}</h3>
                </div>
                {renderEditBar(data, index)}
              </div>
              <p className="nl-bullet">
                &#x2022;&nbsp;{up(data && data.subTitle)}
              </p>
            </article>
          ))}

        {/* ===== Keterlambatan ===== */}
        {listNewsLetter &&
          listNewsLetter.keterlambatan.map((data, index) => (
            <article className="nl-card" key={`terlambat-${index}`}>
              <div className="nl-card-head nl-card-head-center">
                <span className="nl-badge nl-badge-terlambat">
                  Keterlambatan
                </span>
                <h3 className="nl-card-title">{up(data && data.title)}</h3>
                <p className="nl-card-sub">{up(data && data.subTitle)}</p>
              </div>
              {renderEditBar(data, index)}
              <div className="nl-table-scroll">
                <table className="nl-table">
                  <thead>
                    <tr>
                      <th className="col-no">No.</th>
                      <th>Tgl</th>
                      <th>Nama</th>
                      <th>Bagian</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.list.map((obj, i) => (
                      <tr key={i} className={isMe(obj)}>
                        <td className="col-no">{i + 1}.</td>
                        {data && data.isEdit ? (
                          <td>
                            <input
                              className="nl-input nl-input-sm"
                              type="text"
                              name="tglTerlambat"
                              value={obj && obj.tglTerlambat}
                              onChange={(e) =>
                                handleFormChange(data, index, e, true, i)
                              }
                            />
                          </td>
                        ) : (
                          <td>{up(obj && obj.tglTerlambat)}</td>
                        )}
                        <td>{up(obj && obj.name)}</td>
                        <td>{up(obj && obj.bagian)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </article>
          ))}

        {/* ===== S / I / A ===== */}
        {listNewsLetter &&
          listNewsLetter.sia.map((data, index) => (
            <article className="nl-card" key={`sia-${index}`}>
              <div className="nl-card-head nl-card-head-center">
                <span className="nl-badge nl-badge-sia">S / I / A</span>
                {data && data.isEdit ? (
                  <div className="nl-edit-titles">
                    <input
                      className="nl-input"
                      type="text"
                      name="title"
                      placeholder="Judul Berita"
                      value={data && data.title}
                      onChange={(e) => handleFormChange(data, index, e)}
                    />
                    <input
                      className="nl-input"
                      type="text"
                      name="subTitle"
                      placeholder="Sub Title"
                      value={data && data.subTitle}
                      onChange={(e) => handleFormChange(data, index, e)}
                    />
                  </div>
                ) : (
                  <>
                    <h3 className="nl-card-title">{up(data && data.title)}</h3>
                    <p className="nl-card-sub">{data && data.subTitle}</p>
                  </>
                )}
              </div>
              {renderEditBar(data, index)}
              <div className="nl-table-scroll">
                <table className="nl-table">
                  <thead>
                    <tr>
                      <th className="col-no">No.</th>
                      <th>Nama</th>
                      <th>Bagian</th>
                      <th className="col-sia">S</th>
                      <th className="col-sia">I</th>
                      <th className="col-sia">A</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.list.map((obj, i) => (
                      <tr key={i} className={isMe(obj)}>
                        <td className="col-no">{i + 1}.</td>
                        <td>{obj && obj.name}</td>
                        <td>{obj && obj.bagian}</td>
                        {["s", "i", "a"].map((k) =>
                          data && data.isEdit ? (
                            <td key={k} className="col-sia">
                              <input
                                className={`nl-input nl-input-sia${err}`}
                                type="number"
                                name={k}
                                placeholder={k.toUpperCase()}
                                value={obj[k]}
                                onChange={(e) =>
                                  handleFormChange(data, index, e, true, i)
                                }
                                onWheel={(e) => e.target.blur()}
                              />
                            </td>
                          ) : (
                            <td key={k} className="col-sia">
                              {obj[k] ? obj[k] : 0}
                            </td>
                          )
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </article>
          ))}
      </div>
    </div>
  );
};
export default NewsLetter;
